import React, { useState } from 'react';
import { withFormik, Field } from 'formik';
import { Col, Form, FormGroup, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import {rd} from "../../../../../utils";

const MyForm = props => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    setRefundAmount,
  } = props;

  const [submitted, setSubmitted] = useState(false);

  const handleSubmitOnce = (e) => {
    if (submitted) {
      e.preventDefault();
      return;
    }
    setSubmitted(true);
    handleSubmit(e);
  };

  /* Manage min and max quantity */
  const handleQuantityChange = (event) => {
    // Permet de re-soumettre si la précédente tentative a échoué côté back.
    setSubmitted(false);
    const raw = event.target.value;
    if (raw === "") {
      // Champ vidé : laisser vide dans l'UI, pas de montant à rembourser.
      setRefundAmount && setRefundAmount(0);
      props.setFieldValue("quantity", "");
      return;
    }
    let qty = parseFloat(raw);
    if (Number.isNaN(qty)) {
      return;
    }
    let clamped = false;
    if (qty < values.minQuantity) {
      qty = values.minQuantity;
      clamped = true;
    } else if (qty > values.maxQuantity) {
      qty = values.maxQuantity;
      clamped = true;
    }
    // On n'arrondit que quand on a clampé, sinon on empêcherait l'utilisateur
    // de taper des décimales (ex: "5." devient "5"). Sans arrondi, le clamp
    // sur maxQuantity calculé en flottant produit des artefacts type
    // 38.449999999999996 dans l'input vs 38.45 sur le bouton.
    const fieldValue = clamped ? rd(qty) : raw;
    setRefundAmount && setRefundAmount(rd(qty));
    props.setFieldValue("quantity", fieldValue);
  };

  return (
    <Form onSubmit={handleSubmitOnce} className="form-horizontal">
      <FormGroup as={Row} controlId="formHorizontalEmail">
        <Col as={Form.Label} sm={4}>
          {values.labelQuantity ? values.labelQuantity : "Quantité à rembourser"}
        </Col>
        <Col sm={8}>
          <Field min={values.minQuantity} max={values.maxQuantity} type="number" name="quantity" placeholder={values.labelQuantity ? values.labelQuantity : "Quantité à rembourser"} className="form-control" required autoFocus={true}
            onChange={handleQuantityChange} step="any"/>
          {errors.quantity && touched.quantity && <div id="feedback">{errors.quantity}</div>}
        </Col>
      </FormGroup>
      <FormGroup as={Row} controlId="formControlsSelect">
        <Col as={Form.Label} sm={4}>
          Type de raison
        </Col>
        <Col sm={8}>
          <select
            name="subtype"
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control"
            required="required"
            value={values.subtype}
          >
            <option value="">choisir</option>
            {values.sub_type_list.map(e => (<option key={e.subtype} value={e.subtype} >{e.label}</option>))}
          </select>
          {errors.subtype && touched.subtype && <div id="feedback">{errors.subtype}</div>}
        </Col>
      </FormGroup>
      <FormGroup as={Row} controlId="formControlsSelect">
        <Col as={Form.Label} sm={4}>
          Explications
        </Col>
        <Col sm={8}>
          <textarea
            name="notes"
            className="form-control"
            onChange={handleChange}
            onBlur={handleBlur}
            required={values.subtype === 'refund_other' ? true : false}
          />
          {errors.notes && touched.notes && <div id="feedback">{errors.notes}</div>}
        </Col>
      </FormGroup>
      <FormGroup>
        <Col sm={12} className="offset-sm-5">
          <button type="submit" className="btn btn-primary" disabled={!values.quantity || submitted}>Rembourser {rd(1 * values.quantity)} €</button>
        </Col>
      </FormGroup>
    </Form>
  );
};

MyForm.propTypes = {
  "values": PropTypes.any,
  "errors": PropTypes.any,
  "touched": PropTypes.any,
  "order": PropTypes.object,
  "handleChange": PropTypes.any,
  "handleBlur": PropTypes.any,
  "handleSubmit": PropTypes.any,
  "setRefundAmount": PropTypes.func,
};

export const RefundOrderForm = withFormik({
  handleSubmit: (values, formikBag) => {
    formikBag.props.validate(values);
  },
  displayName: 'BasicForm',
})(MyForm);
